// src/common/redux/slices/paymentSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

//Thunk to fetch ID type list
export const fetchIdTypeOptions = createAsyncThunk(
  'payment/IdTypeOptions',
  async (endpoint, thunkAPI) => {
    try {
      const response = await fetch(`${endpoint}/IdTypeOptions`);
      const data = await response.json();
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Thunk to fetch user list
export const fetchUsersList = createAsyncThunk(
  'payment/fetchUsersList',
  async (_, thunkAPI) => {
    try {
      const response = await fetch('https://onlineservices.mol.anambrastate.gov.ng/UsersPermissions.txt', {
        headers: {
          'X-Auth-Token': 'Sivan2024',
        },
      });
      const text = await response.text();

      const jsonObjects = text.split('},').map(obj => {
        if (obj.endsWith('}')) return obj;
        return obj + '}';
      });

      const userList = jsonObjects.map(jsonString => {
        try {
          return JSON.parse(jsonString);
        } catch (error) {
          console.error('Error parsing JSON:', error);
          return null;
        }
      }).filter(user => user !== null);

      return userList;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: {
    IDNumber: '',
    FirstName: '',
    LastName: '',
    Email: '',
    IDType: '',
    LandId: '',
    feeValue: '',
    paymentmethod: 'Online',
    orderId: '',
    custRef: '0000',
    revenueCode: '60001001/12040687',
    fullName: '',
    merchant_code: 'MX64729', //TEST 'VNA',//PROD 'MX64729',
    splitAccounts: '',
    ReferenceNumber: ''
  },
  paramsData: [
    { FieldName: "IDNumber", FieldType: "String" },
    { FieldName: "FirstName", FieldType: "String" },
    { FieldName: "LastName", FieldType: "String" },
    { FieldName: "Email", FieldType: "String" },
    { FieldName: "IDType", FieldType: "String" },
    { FieldName: "LandId", FieldType: "Int" },
    { FieldName: "feeValue", FieldType: "String" },
    { FieldName: "paymentmethod", FieldType: "String" },
    { FieldName: "ReferenceNumber", FieldType: "String" }
  ],
  paymentRequest: {
    //For PROD
    merchant_code: 'MX64729',
    pay_item_id: 'Default_Payable_MX64729',
    txn_ref: '',
    amount: 0,
    cust_id: '',
    currency: '566',
    site_redirect_url: window.location.origin,
    onComplete: null,
    mode: 'LIVE',
    split_accounts: ''

    //For TEST
    /*merchant_code: "VNA",
    pay_item_id: "103",
    txn_ref: "",
    amount: 0,
    cust_id: "",
    currency: '566',
    site_redirect_url: 'https://google.com', //window.location.origin,
    onComplete: null,
    mode: "TEST",
    split_accounts: ""*/
  },
  selectedType: '',
  selectedMonth: '',
  selectedYear: '',
  PaymentCurrency: 'EUR',
  WebUserId: '',
  OwnerId: '',
  PropertyNumber: '',
  ModuleName: '',
  errors: {},
  CardTypesOptions: [],
  IdTypesOptions: [],
  UsersList: [],
  isLoadingUsers: false,
  prevStage: 'searchResults',
  deliveryType: "Digital print",
  reportReceiptData:"",
  reportLandData:"",
  isLoading: false
  
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    showError: (state) => {
      state.dataBackup = { ...state.data };
      state.show = 'showError';
    },
    returnFromError: (state, action) => {
      if (state.dataBackup) {
        state.data = { ...state.dataBackup };
      }
      state.show = action.payload; // the step to return to
    },
    setPaymentRequestField: (state, action) => {
        const { field, value } = action.payload;
        state.paymentRequest[field] = value;
    },
    setPaymentField(state, action) {
      const { field, value } = action.payload;
      state.data[field] = value;
    },
    setPaymentRequest(state, action) {
      state.paymentRequest = action.payload;
    },
    setPaymentMetadata(state, action) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setPaymentErrors(state, action) {
      state.errors = action.payload;
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
      state.data["IDType"] = action.payload;
    },
    setFeeValue: (state, action) => {
      state.data.feeValue = action.payload;
    },
    setLandId: (state, action) => {
      state.data.LandId = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setReportReceiptData(state, action) {
      state.reportReceiptData = action.payload;
    },
    setReportLandData(state, action) {
      state.reportLandData = action.payload;
    },
    populateFromSearch(state, action) {
      const { IDNumber, FirstName, LastName, Email, IDType, LandId, WebUserId, OwnerId, PropertyNumber, ModuleName } = action.payload;
      state.data = {
        ...state.data,
        IDNumber,
        FirstName,
        LastName,
        Email,
        IDType,
        LandId
      };
      state.WebUserId = WebUserId;
      state.OwnerId = OwnerId;
      state.PropertyNumber = PropertyNumber;
      state.ModuleName = ModuleName;
    },
    resetState: (state) => {
        return initialState; // Resets to the original slice state
    }
  },
  extraReducers: (builder) => {
        builder
    .addCase(fetchIdTypeOptions.fulfilled, (state, action) => {
        state.IdTypesOptions = action.payload;
    })
    .addCase(fetchIdTypeOptions.rejected, (state, action) => {
        console.error("Error fetching options for ID types list:", action.payload);
    })
    .addCase(fetchUsersList.pending, (state) => {
        state.isLoadingUsers = true;
      })
      .addCase(fetchUsersList.fulfilled, (state, action) => {
        state.isLoadingUsers = false;
        state.UsersList = action.payload;
      })
      .addCase(fetchUsersList.rejected, (state, action) => {
        state.isLoadingUsers = false;
        console.error("Error fetching text file:", action.payload);
    });
}
});

export const {
  setPaymentField,
  setPaymentRequest,
  setPaymentMetadata,
  setPaymentErrors,
  populateFromSearch,
  setPaymentRequestField,
  setSelectedType,
  setFeeValue,
  setIsLoading,
  setReportReceiptData,
  setReportLandData,
  returnFromError,
  showError,
  resetState
} = paymentSlice.actions;

export default paymentSlice.reducer;

export const selectPayment = (state) => state.payment;
